<template>
  <div>
    <v-card class="mb-4" :loading="loading">
      <v-system-bar>Archiv</v-system-bar>
      <JustificationList
        :items="justificationsArchived"
        hideStudent
        :schoolClass="student.schoolClass"
      />
    </v-card>

    <v-card class="mb-4" :loading="loading">
      <v-system-bar>Ignorierte Absenzen</v-system-bar>
      <AbsenceList
        :items="absencesIgnored"
        hideStudent
        :actions="['reactivate']"
        :schoolClass="student.schoolClass"
        @updated="fetchData()"
      />
    </v-card>

    <router-view
      @updated="fetchData()"
      :student="student"
      :schoolClass="student.schoolClass"
    />
  </div>
</template>
<script>
import { defineComponent } from "vue";
import AbsenceList from "common/components/AbsenceList.vue";
import JustificationList from "common/components/JustificationList.vue";

export default defineComponent({
  components: {
    JustificationList,
    AbsenceList,
  },
  props: {
    id: { type: Number, default: 0 },
    term: { startDate: 0 },
    student: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      loading: false,
      justificationsArchived: [],
      absencesIgnored: [],
    };
  },
  computed: {
    canEdit() {
      return this.$_isClassTeacherOf(this.student);
    },
  },
  watch: {
    id(oldValue, newValue) {
      if (oldValue != newValue) {
        this.fetchData();
      }
    },
    term() {
      this.fetchData();
    },
  },

  methods: {
    async fetchData() {
      if (!this.id || !this.term) return;
      this.loading = true;

      this.justificationsArchived = await this.apiList({
        resource: "absence/justification",
        query: `archived&student=${this.id}&term=${this.term.id}`,
      });
      // bei vergangenen Semestern weren nicht balancierte Entschuldigungen ausgeblendet
      if (!this.term.current) {
        this.justificationsArchived = this.justificationsArchived.filter(
          (j) => j.balanced
        );
      }

      this.absencesIgnored = await this.apiList({
        resource: "absence/absence",
        query: `ignored&student=${this.id}&term=${this.term.id}`,
      });

      this.loading = false;
    },

    showDetails(el) {
      if (el.event.id) {
        if (this.$_hasRole("student")) {
          this.$router.push({
            name: "JustificationStudentDetail",
            params: { id: this.id, justificationId: el.event.id },
          });
        } else {
          this.$router.push({
            name: "JustificationOverviewDetail",
            params: { id: this.id, justificationId: el.event.id },
          });
        }
      } else if (el.event.absences) {
        this.eventIndex = this.events.findIndex(
          (event) => event.date == el.event.date
        );
        this.dialog = true;
      }
    },
  },
  created() {
    this.fetchData();
  },
});
</script>
